var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44696 8.5H5.44696V10.5H10.447V5.5H8.44696V8.5ZM5.44696 13.5002V15.5002H8.44696V18.5002H10.447V13.5002H5.44696Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.553 8.5H18.553V10.5H13.553V5.5H15.553V8.5ZM18.553 13.5002V15.5002H15.553V18.5002H13.553V13.5002H18.553Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseFullscreen);
export default __webpack_public_path__ + "static/media/collapse-fullscreen.90cdba320e6730f3c4634c16ca55fa17.svg";
export { ForwardRef as ReactComponent };